import React from 'react';

import { Box, Button, H1, PancakeStack, Separator, Sheet } from '@betterment/samba-react';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityClient } from '../../../types';
import { ClientName } from '../../ClientName';

interface ActivityDrawerLayoutProps {
  title: string;
  users: ActivityClient[];
}

export const ActivityDrawerLayout: React.FC<React.PropsWithChildren<ActivityDrawerLayoutProps>> = ({
  title,
  users,
  children,
}) => {
  return (
    <PancakeStack css={{ px: 'space.400', pt: 'space.400' }}>
      <PancakeStack.Header>
        <Sheet.Title asChild={true}>
          <H1 variant="title300">{title}</H1>
        </Sheet.Title>
      </PancakeStack.Header>
      <PancakeStack.Main css={{ pt: 'space.200' }}>
        <DrawerListRow label="Client" value={<ClientName users={users} />} />
        <Separator />
        {children}
      </PancakeStack.Main>
      <PancakeStack.Footer
        css={{
          borderColor: 'border',
          borderTop: 'solid 1px',
          pb: 'space.200',
          py: 'space.200',
        }}
      >
        <Sheet.Trigger asChild={true}>
          <Box>
            <Button variant="solidSecondary">Close</Button>
          </Box>
        </Sheet.Trigger>
      </PancakeStack.Footer>
    </PancakeStack>
  );
};
